<template>
  <div class="container" @mouseleave="btnShow = false" @mouseenter="btnShow = true">
    <div class="card-title">
      <h4 class="title">{{dish.dish_native_name ? dish.dish_native_name : "暂无"}}</h4>
      <span v-if="btnShow">
        <el-button type="text" @click="emitDelete" class="btn danger-text"><i class="el-icon-delete"></i></el-button>
      <el-button type="text" @click="emitEdit" class="btn"><i class="el-icon-edit"></i></el-button>
      </span>
    </div>
    <div class="card-body">
      <classDishWrapper :image="dish" class="class-dish-wrapper">
      </classDishWrapper>
      <slot name="btn">
      </slot>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import classDishWrapper from '_c/classDishWrapper';

export default {
  name: 'dishCard',
  components: {classDishWrapper},
  props: {
    dish: {
      type: Object
    }
  },
  data () {
    return {
      btnShow: false
    };
  },
  mounted () {

  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    emitDelete () {
      this.$emit('delete', this.dish);
    },
    emitEdit() {
      this.$emit('edit', this.dish);
    },
    ...mapActions([])
  },
  computed: {
    ...mapGetters([])
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
  .container {
    width: 100%;
    height: 100%;
    border: 1px solid #ccc;
    border-radius: 2px;
    margin-bottom: 5px;
    .card-title {
      padding: 10px 5px;
      .title {
        display: inline-block;
      }
      .btn {
        float: right;
        padding: 0 2px;
        display: inline-block;
      }
    }
    .card-body {
      text-align: center;
    }
    .class-dish-wrapper {
      display: inline-block;
      width: 120px;
      height: 120px;
    }
  }

</style>
